module.exports = __webpack_public_path__ + "img/ideal.0e85b4a4.svg";